/**
 * ScrollImageTunnel — vanilla JS port of the original React/Framer-Motion
 * component. Same math, same timings, same "small dot -> full frame,
 * oversaturated -> true color" reveal per photo.
 */
(function () {
  function clamp(v, min, max) {
    return Math.max(min, Math.min(max, v));
  }

  // Piecewise-linear interpolation, equivalent to framer-motion's useTransform
  function interpolate(value, inputRange, outputRange) {
    if (value <= inputRange[0]) return outputRange[0];
    var last = inputRange.length - 1;
    if (value >= inputRange[last]) return outputRange[last];
    for (var i = 0; i < last; i++) {
      if (value >= inputRange[i] && value <= inputRange[i + 1]) {
        var t = (value - inputRange[i]) / (inputRange[i + 1] - inputRange[i]);
        return outputRange[i] + t * (outputRange[i + 1] - outputRange[i]);
      }
    }
    return outputRange[last];
  }

  function initInstance(root) {
    if (!root || root.dataset.sitInitialized) return;
    root.dataset.sitInitialized = 'true';

    var layers = Array.prototype.slice.call(root.querySelectorAll('.sit-layer'));
    var frames = layers.map(function (l) { return l.querySelector('.sit-frame'); });
    var stickyEl = root.querySelector('.sit-sticky');
    var total = layers.length;
    if (!total) return;

    var stepHeightVh = parseFloat(
      getComputedStyle(root).getPropertyValue('--sit-step-height')
    ) || 200;

    var reduceMotion = window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var ticking = false;

    function setHeight() {
      root.style.height = (total * stepHeightVh) + 'vh';
    }

    function update() {
      ticking = false;
      var rect = root.getBoundingClientRect();
      var viewport = stickyEl ? stickyEl.clientHeight : window.innerHeight;
      var denom = rect.height - viewport || 1;
      var progress = clamp(-rect.top / denom, 0, 1);

      layers.forEach(function (layer, index) {
        var frame = frames[index];
        if (!frame) return;

        var local = interpolate(
          progress,
          [index / total, (index + 1) / total],
          [0, 1]
        );

        if (reduceMotion) {
          layer.style.opacity = 1;
          frame.style.transform = 'none';
          frame.style.filter = 'none';
          layer.style.zIndex = index;
          return;
        }

        var scale = interpolate(local, [0, 0.8], [0.05, 1]);
        var y = interpolate(local, [0, 0.75], [40, 0]);
        var opacity = interpolate(local, [0, 0.03, 1], [0, 1, 1]);
        var contrast = interpolate(local, [0, 0.7], [2.2, 1]);
        var saturate = interpolate(local, [0, 0.7], [2.6, 1]);

        layer.style.zIndex = index;
        layer.style.opacity = opacity.toFixed(3);
        frame.style.transform =
          'scale(' + scale.toFixed(3) + ') translateY(' + y.toFixed(2) + 'px)';
        frame.style.filter =
          'contrast(' + contrast.toFixed(3) + ') saturate(' + saturate.toFixed(3) + ')';
      });
    }

    function onScroll() {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(update);
      }
    }

    setHeight();
    window.addEventListener('resize', function () {
      setHeight();
      onScroll();
    });
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  window.ScrollImageTunnel = {
    init: function (root) {
      initInstance(root);
    }
  };

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('.sit-wrapper');
    if (root) initInstance(root);
  });
})();